module.exports = __webpack_public_path__ + "img/general-error.8d97024.png";